import {useMemo} from 'react'
import {useFormContext} from 'react-hook-form'

import {useConfigContext} from '../../../contexts'
import {DeliveryType} from '../types'
import {mapVerticalToDeliveryType} from '../utils/map-vertical-to-delivery-type'

export function useSourcePointCoordinates() {
  const {location} = useConfigContext()
  const {watch} = useFormContext()
  const nddCoordinates = watch('ndd.route.source.pickupPoint.coordinates')
  const sddCoordinates = watch('route.source.address.coordinates')

  const deliveryType = mapVerticalToDeliveryType(watch('selected_submode'))

  return useMemo(() => {
    switch (deliveryType) {
      case DeliveryType.Express:
      case DeliveryType.SDD:
        return sddCoordinates
      case DeliveryType.NDD:
        return nddCoordinates || location
    }
  }, [deliveryType, location, nddCoordinates, sddCoordinates])
}
